document.addEventListener('DOMContentLoaded', function() {
    const ctx = document.getElementById('bacteria-chart');
    if (!ctx) return;

    const isMobile = window.innerWidth < 768;

    // Gradientes para as áreas
    const ctx2d = ctx.getContext('2d');
    
    const garrafaGradient = ctx2d.createLinearGradient(0, 0, 0, 400);
    garrafaGradient.addColorStop(0, 'rgba(37, 99, 235, 0.2)');   // Azul principal
    garrafaGradient.addColorStop(1, 'rgba(37, 99, 235, 0)');

    const vasoGradient = ctx2d.createLinearGradient(0, 0, 0, 400);
    vasoGradient.addColorStop(0, 'rgba(124, 58, 237, 0.2)');     // Roxo vibrante
    vasoGradient.addColorStop(1, 'rgba(124, 58, 237, 0)');

    const macanetaGradient = ctx2d.createLinearGradient(0, 0, 0, 400);
    macanetaGradient.addColorStop(0, 'rgba(236, 72, 153, 0.2)'); // Rosa moderno
    macanetaGradient.addColorStop(1, 'rgba(236, 72, 153, 0)');

    new Chart(ctx, {
        type: 'line',
        data: {
            labels: ['0h', '12h', '24h', '36h', '48h'],
            datasets: [{
                label: 'Garrafa d\'água',
                data: [100, 5000, 25000, 100000, 400000],
                borderColor: '#2563EB',
                backgroundColor: garrafaGradient,
                tension: 0.4,
                borderWidth: 3,
                fill: true,
                pointRadius: 0,
                pointHoverRadius: 8,
                pointHoverBackgroundColor: '#2563EB',
                pointHoverBorderColor: '#fff',
                pointHoverBorderWidth: 2
            }, {
                label: 'Vaso sanitário',
                data: [100, 200, 500, 2500, 10000],
                borderColor: '#7C3AED',
                backgroundColor: vasoGradient,
                tension: 0.4,
                borderWidth: 3,
                fill: true,
                pointRadius: 0,
                pointHoverRadius: 8,
                pointHoverBackgroundColor: '#7C3AED',
                pointHoverBorderColor: '#fff',
                pointHoverBorderWidth: 2
            }, {
                label: 'Maçaneta',
                data: [100, 150, 300, 800, 2000],
                borderColor: '#EC4899',
                backgroundColor: macanetaGradient,
                tension: 0.4,
                borderWidth: 3,
                fill: true,
                pointRadius: 0,
                pointHoverRadius: 8,
                pointHoverBackgroundColor: '#EC4899',
                pointHoverBorderColor: '#fff',
                pointHoverBorderWidth: 2
            }]
        },
        options: {
            layout: {
                padding: {
                    top: 20,
                    right: 20,
                    bottom: isMobile ? 40 : 20,
                    left: 20
                }
            },
            responsive: true,
            maintainAspectRatio: false,
            interaction: {
                mode: 'nearest',
                axis: 'x',
                intersect: false
            },
            scales: {
                y: {
                    type: 'logarithmic',
                    grid: {
                        display: false  // Remove as linhas horizontais do grid
                    },
                    border: {
                        display: false
                    },
                    ticks: {
                        callback: function(value) {
                            if (value === 100) return '100';
                            if (value === 1000) return '1k';
                            if (value === 10000) return '10k';
                            if (value === 100000) return '100k';
                            if (value === 1000000) return '1M';
                            return '';
                        },
                        font: {
                            size: isMobile ? 11 : 13,
                            family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                        },
                        padding: 8
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    border: {
                        display: false
                    },
                    ticks: {
                        font: {
                            size: isMobile ? 11 : 13,
                            family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                        },
                        padding: 8
                    },
                    title: {
                        display: true,
                        text: 'Horas sem limpeza*',
                        padding: {
                            top: 15
                        },
                        font: {
                            size: isMobile ? 12 : 14,
                            family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                        }
                    }
                }
            },
            plugins: {
                tooltip: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    titleColor: '#1F2937',
                    bodyColor: '#4B5563',
                    borderColor: 'rgba(156, 163, 175, 0.2)',
                    borderWidth: 1,
                    cornerRadius: 8,
                    padding: 12,
                    boxPadding: 6,
                    usePointStyle: true,
                    titleFont: {
                        size: 13,
                        weight: '600',
                        family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                    },
                    bodyFont: {
                        size: 12,
                        family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                    },
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
                            let value = context.parsed.y;
                            if (label) {
                                label += ': ';
                            }
                            if (value >= 1000000) {
                                label += (value / 1000000).toFixed(1) + 'M';
                            } else if (value >= 1000) {
                                label += (value / 1000).toFixed(1) + 'k';
                            } else {
                                label += value;
                            }
                            label += ' UFC/cm²';
                            return label;
                        }
                    }
                },
                legend: {
                    position: 'bottom',
                    align: 'start',
                    rtl: false,
                    labels: {
                        usePointStyle: true,
                        padding: isMobile ? 15 : 20,
                        boxWidth: isMobile ? 8 : 10,
                        boxHeight: isMobile ? 8 : 10,
                        font: {
                            size: isMobile ? 12 : 14,
                            family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                        }
                    },
                    maxWidth: isMobile ? 160 : undefined,
                    maxHeight: isMobile ? 100 : undefined
                },
                title: {
                    display: true,
                    text: 'O Perigo Invisível',
                    color: '#111827',
                    font: {
                        size: isMobile ? 20 : 24,
                        weight: '600',
                        family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                    },
                    padding: {
                        top: 10,
                        bottom: 10
                    }
                },
                subtitle: {
                    display: true,
                    text: 'Crescimento bacteriano comparativo em 48 horas',
                    color: '#6B7280',
                    font: {
                        size: isMobile ? 13 : 16,
                        family: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                    },
                    padding: {
                        bottom: 25
                    }
                }
            }
        }
    });
});